import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import Delta from '../Delta';

storiesOf('base', module).add('Delta', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Delta</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>Delta</Code> component is used to display changes in
          percentage values. The amount of change is passed into the component
          via the <Code>value</Code> prop.
        </Text>
        <Spacer size={16} />
        <FlexView direction="horizontal">
          <FlexView align="center" expand={false}>
            <Delta value={25} />
            <Spacer size={6} />
            <Code>{'value={25}'}</Code>
          </FlexView>
          <Spacer direction="horizontal" size={16} />
          <FlexView align="center" expand={false}>
            <Delta value={-25} />
            <Spacer size={6} />
            <Code>{'value={-25}'}</Code>
          </FlexView>
        </FlexView>
        <Spacer size={16} />
        <Heading level={2}>Zero Value</Heading>
        <Spacer size={16} />
        <Text>
          If the <Code>value</Code> prop passed into the <Code>Delta</Code>{' '}
          component is <Code>0</Code> then the triangle icon will not be
          rendered.
        </Text>
        <Spacer size={16} />
        <FlexView align="center" expand={false}>
          <Delta value={0} />
          <Spacer size={6} />
          <Code>{'value={0}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <Heading level={2}>NaN Value</Heading>
        <Spacer size={16} />
        <Text>
          If the <Code>value</Code> prop passed into the <Code>Delta</Code>{' '}
          component is <Code>NaN</Code>, <Code>Infinity</Code> or{' '}
          <Code>-Infinity</Code> then the triangle icon will not be rendered.
        </Text>
        <Spacer size={16} />
        <FlexView align="center" expand={false}>
          <Delta value={NaN} />
          <Spacer size={6} />
          <Code>{'value={NaN}'}</Code>
        </FlexView>
      </FlexView>
    </Spacing>
  </ScrollView>
));
